import React, { Component } from 'react';
import plus from '../../../../Images/Icons/plus.png';
import back from '../../../../Images/back.png';
import delete_icon from '../../../../Images/Icons/delete.png';

import { makeTimeString, isEmpty } from '../../../Common/Common';

import Switch from '../../../Part_Sample/Switch';
import Editbox from '../../../Part_Sample/Editbox';
import Button from '../../../Part_Sample/Button';
import Select from '../../../Part_Sample/Select';
import Modal from '../../../Part_Sample/Modal';
import Repeat from '../Components/Repeat';
import Top_Bar from '../../../Part_Sample/Top_Bar'; //Tommy - 05/03/2021

import Command_Power from '../../../Commands/Command_Power_On_Off';
import Command_Setpoint from '../../../Commands/Command_Setpoint';
import Command_Hum_Setpoint from '../../../Commands/Command_Hum_Setpoint';
import Command_Fanstep from '../../../Commands/Command_Fanstep';
import Command_Mode from '../../../Commands/Command_Mode';
import Command_Off_Timer from '../../../Commands/Schedule_Commands/Command_Off_Timer';
import Command_Notification from '../../../Commands/Schedule_Commands/Command_Notification';

//Tommy - 24/02/2021
import Command_Lock from '../../../Commands/Command_Lock';
import Command_Shutter from '../../../Commands/Command_Shutter';
import Command_RGB_Input from '../../../Commands/Command_RGB_Input';

//Tommy - 08/03/2021
import Command_RC_Proh_Op from '../../../Commands/Schedule_Commands/Command_RC_Proh_Op';
import Command_RC_Proh_Mode from '../../../Commands/Schedule_Commands/Command_RC_Proh_Mode';
import Command_RC_Proh_SP from '../../../Commands/Schedule_Commands/Command_RC_Proh_SP';
import Command_RC_Proh_Fanstep from '../../../Commands/Schedule_Commands/Command_RC_Proh_Fanstep';

//Tommy - 08/04/2021
import Command_Level from '../../../Commands/Command_Level';

//Tommy - 12/04/2021
import Command_Setback_Cool from '../../../Commands/Schedule_Commands/Command_Setback_Cool';
import Command_Setback_Heat from '../../../Commands/Schedule_Commands/Command_Setback_Heat';

//Tomy - 24/06/2021 - Added Special Calendar component
import Special_Calendar from '../Components/Special_Calendar';

export default class Add_Edit_Schedule_Home extends Component {
	constructor(props) {
		super(props);
		this.is_modify_pattern_ok = false;
		this.is_modify_schedule_ok = false;
		this.is_delete_pattern_ok = false;
		this.is_delete_schedule_ok = false;

		this.lastClickTime = false;

		let schedule_name = '';
		let hour = '00';
		let min = '00';
		let wd = [];
		let target = '';
		let scene_target_list = [];
		let action_details = {};
		let is_enabled = false;
		let selected_calendar_id = ''; // Tommy - 24/06/2021 

		if (this.props.param.program_id != null) {
			let program = this.props.param.schedule.program[this.props.param.program_id];
			if (!isEmpty(program.action)) {
				this.pattern_id = Object.keys(program.action)[0];
				let pattern = this.props.param.schedule.pattern[this.pattern_id];
				if (!isEmpty(pattern)) {
					if (!isEmpty(pattern.action)) {
						let time = Object.keys(pattern.action)[0];
						hour = time.substring(0, 2);
						min = time.substring(3, 5);
						action_details = pattern.action[time];
					}
				}
				if (!isEmpty(program.action[this.pattern_id])) {
					wd = program.action[this.pattern_id].exec_dow;
				}

				//Tommy - 24/06/2021
				// Currently only 1 special day calendar can be selected (new requirement)
				if (program.action[this.pattern_id].exec_cal.length > 0) {
					selected_calendar_id = program.action[this.pattern_id].exec_cal[0];
				}

				//Tommy - 24/06/2021 - Check if calendar has been deleted
				if (isEmpty(this.props.param.schedule.calendar[selected_calendar_id])) selected_calendar_id = '';

			}

			schedule_name = program.name != null ? program.name : '';
			is_enabled = program.exec != null ? program.exec : false

			for (let id of program.target) {
				if (!isEmpty(window.app.state.point_list[id])) {
					target = id;
				} else if (!isEmpty(this.props.param.scenes[id])) {
					scene_target_list.push(id);
				}
			}
		}

		this.devices = [];
		let point_list = window.app.state.point_list;

		// Tommy - 03/09/2021 - Add a default placeholder
		this.devices.push(<option value={""}>{this.props.receiver.getString('sel_device')}</option>);

		for (let point_id in point_list) {
			let point = point_list[point_id];

			// Tommy - 31/03/2021 - Only add management points which are operationable
			if (point.op_cap) this.devices.push(<option value={point_id}>{point.name}</option>);
		}

		let days_of_week = [
			{
				key: 0,
				display: this.props.receiver.getString('s_sun'),
				is_checked: wd.includes(0) ? true : false,
			},
			{
				key: 1,
				display: this.props.receiver.getString('s_mon'),
				is_checked: wd.includes(1) ? true : false,
			},
			{
				key: 2,
				display: this.props.receiver.getString('s_tue'),
				is_checked: wd.includes(2) ? true : false,
			},
			{
				key: 3,
				display: this.props.receiver.getString('s_wed'),
				is_checked: wd.includes(3) ? true : false,
			},
			{
				key: 4,
				display: this.props.receiver.getString('s_thu'),
				is_checked: wd.includes(4) ? true : false,
			},
			{
				key: 5,
				display: this.props.receiver.getString('s_fri'),
				is_checked: wd.includes(5) ? true : false,
			},
			{
				key: 6,
				display: this.props.receiver.getString('s_sat'),
				is_checked: wd.includes(6) ? true : false,
			}
		];

		let scene_list_display = [];
		for (let scene_id in this.props.param.scenes) {
			let line_item = {};
			line_item.key = scene_id;
			line_item.display = this.props.param.scenes[scene_id].name;
			line_item.is_checked = scene_target_list.includes(scene_id) ? true : false;
			scene_list_display.push(line_item)
		}

		// Tommy - 25/06/2021 - Display the changes user made prior to opening special day calendar
		if (this.props.param.edit != null) {
			let schedule_edit = this.props.param.edit;
			schedule_name = schedule_edit.schedule_name;
			is_enabled = schedule_edit.is_enabled;
			hour = schedule_edit.hour;
			min = schedule_edit.min;

			// Tommy - 03/09/21 - Check if point id can be found in point list
			if (!isEmpty(point_list[schedule_edit.target])) target = schedule_edit.target;
			else target = "";

			scene_list_display = schedule_edit.scene_list_display;
			action_details = schedule_edit.action_details;
			days_of_week = schedule_edit.days_of_week;

			if (this.props.param.program_id == null) {
				selected_calendar_id = schedule_edit.selected_calendar_id;
			}

			//Tommy - 25/06/2021 - Show the newly added calendar if exist
			if (this.props.param.program_id != null && schedule_edit.selected_calendar_id != '') {
				selected_calendar_id = schedule_edit.selected_calendar_id;
			}

		}

		this.state = {
			schedule_name: schedule_name,
			hour: hour,
			min: min,
			days_of_week: days_of_week,
			is_enabled: is_enabled,
			target: target,
			action_details: action_details,
			scene_list_display: scene_list_display,
			is_show_modal: false,
			selected_calendar_id: selected_calendar_id //Tommy - 24/06/2021
		}
	}

	preventMultipleTaps = () => {
		if(this.lastClickTime == false) {		//Check if it is first click, allow
			this.lastClickTime = true;
			return true;
		} else {
			return false;
		}
	}

	handlePrevious = () => {
		this.props.content_handler('Schedule', { schedule: this.props.param.schedule, scenes: this.props.param.scenes, interlock: this.props.param.interlock, groups: this.props.param.groups });
	}

	handleChangeScheduleName = (val) => {
		this.setState({ schedule_name: val })
	}

	handleChangeScheduleTimerHour = (val) => {
		this.setState({ hour: val })
	}

	handleChangeScheduleTimerMin = (val) => {
		this.setState({ min: val })
	}

	handleChangeDaysOfWeek = (key) => {
		let list = [...this.state.days_of_week];

		for (let i in list) {
			if (list[i].key == key) {
				list[i].is_checked = !list[i].is_checked;
				this.setState({
					days_of_week: list,
				});
				break;
			}
		}
	}

	handleToggleEnable = () => {
		this.setState({ is_enabled: !this.state.is_enabled })
	}

	handleChangeTarget = (val) => {
		this.setState({ target: val })
	}

	handleToggleModal = () => {

		// Tommy - 03/09/21 - If selected target is a placeholder, show error message
		if (this.state.target == "") window.app.showToast(this.props.receiver.getString('sel_device'), 3000);
		else {

			this.setState({ is_show_modal: !this.state.is_show_modal })

			// Tommy - 08/03/2021
			if (this.state.is_show_modal) window.app.content_area.current.switch_content.current.handleHideBottomMenu();
			else window.app.content_area.current.switch_content.current.handleShowBottomControls();
		}
	}

	handleSelectScene = (key) => {
		let scene_list_display = this.state.scene_list_display;
		for (let i in scene_list_display) {
			if (scene_list_display[i].key == key) {
				scene_list_display[i].is_checked = !scene_list_display[i].is_checked;
				break;
			}
		}

		this.setState({ scene_list_display: scene_list_display })
	}

	handleChangeStat = (stat) => {
		let action_details = this.state.action_details;
		if (stat != null) {
			action_details.stat = stat
		} else if (action_details.stat != null) {
			delete action_details.stat
		}

		this.setState({ action_details: action_details });
	}

	handleChangeSP = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.sp = val
		} else if (action_details.sp != null) {
			delete action_details.sp
		}

		this.setState({ action_details: action_details });
	}

	handleChangeHumSP = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.hum_sp = val
		} else if (action_details.hum_sp != null) {
			delete action_details.hum_sp
		}

		this.setState({ action_details: action_details });
	}

	handleChangeFanstep = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.fanstep = val
		} else if (action_details.fanstep != null) {
			delete action_details.fanstep
		}

		this.setState({ action_details: action_details });
	}

	handleChangeMode = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.mode = val
		} else if (action_details.mode != null) {
			delete action_details.mode
		}

		this.setState({ action_details: action_details });
	}

	handleChangeOffTimer = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.off_timer = val
		} else if (action_details.off_timer != null) {
			delete action_details.off_timer
		}

		this.setState({ action_details: action_details });
	}

	//Tommy - 24/02/2021
	handleChangeShutterStatus = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.shutter = val
		} else if (action_details.shutter != null) {
			delete action_details.shutter
		}

		this.setState({ action_details: action_details });
	}

	//Tommy - 24/02/2021
	handleChangeLockStatus = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.lock = val
		} else if (action_details.lock != null) {
			delete action_details.lock
		}

		this.setState({ action_details: action_details });
	}

	// Tommy - 02/03/2021
	handleChangeRGB = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			val = val + "FF"; //add in W parameter
			let hex_code = val.substring(1); //remove #
			let rgbw_code = parseInt(hex_code, 16); //Convert hexadecimal to decimal
			action_details.rgbw = rgbw_code
		} else if (action_details.rgbw != null) {
			delete action_details.rgbw
		}

		this.setState({ action_details: action_details });
	}

	handleChangeNotification = (val) => {
		if (val == 'true') {
			val = true;
		} else if (val == 'false') {
			val = false;
		}

		let action_details = this.state.action_details;
		if (val != null) {
			action_details.notify = val
		} else if (action_details.notify != null) {
			delete action_details.notify
		}

		this.setState({ action_details: action_details });
	}

	handleSaveSchedule = () => {
		let selected_scenes = [];
		for (let i in this.state.scene_list_display) {
			if (this.state.scene_list_display[i].is_checked) selected_scenes.push(this.state.scene_list_display[i].key)
		}

		if (this.state.schedule_name == '') {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('no_name'), 3000);
			return;
		} else if (this.state.target == '' && selected_scenes.length == 0) { //&&
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('no_target'), 3000);
			return;
		}

		// Tommy  - 01/04/2021 - User can save a schedule by selecting a scene without selecting a device operation
		if (isEmpty(this.state.action_details) && this.state.scene_list_display.length == 0) {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('no_action'), 3000);
			return;
		}

		// else if (isEmpty(this.state.action_details)) {
		// 	window.app.showToast(this.props.receiver.getString('no_action'), 3000);
		// 	return;
		// }

		let dow = [];
		for (let j in this.state.days_of_week) {
			if (this.state.days_of_week[j].is_checked) {
				dow.push(this.state.days_of_week[j].key);
			}
		}

		//Tommy - 24/06/2021
		let cal_list = [];
		if (this.state.selected_calendar_id != '') cal_list.push(this.state.selected_calendar_id);

		// Tommy - 24/06/2021 - User can save schedule without selecting an execution day
		if (dow.length < 1 && cal_list.length == 0) {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('no_repeat_date'), 3000);
			return;
		}

		let time = this.state.hour + ':' + this.state.min;

		if (this.props.param.program_id == null) {
			let pattern = {};
			pattern.name = 'Reiri Home Pattern';
			pattern.action = {};
			pattern.action[time] = this.state.action_details;

			let program = {};
			program.name = this.state.schedule_name;
			program.exec = this.state.is_enabled;
			program.target = [this.state.target, ...selected_scenes];
			program.action = {};

			this.props.receiver.stored_params.program = program;
			this.props.receiver.stored_params.dow = dow;

			//Tommy - 24/06/2021
			this.props.receiver.stored_params.exec_cal = cal_list;

			this.props.receiver.addPattern(pattern);
		} else {
			let pattern = {};
			pattern[this.pattern_id] = {};
			pattern[this.pattern_id].name = 'Reiri Home Pattern';
			pattern[this.pattern_id].action = {};
			pattern[this.pattern_id].action[time] = this.state.action_details;

			this.props.receiver.modifyPattern(pattern);

			let program = {};
			program[this.props.param.program_id] = {};

			program[this.props.param.program_id].name = this.state.schedule_name;
			program[this.props.param.program_id].exec = this.state.is_enabled;
			program[this.props.param.program_id].target = [this.state.target, ...selected_scenes];
			program[this.props.param.program_id].action = {};

			//Tommy - 24/06/2021
			program[this.props.param.program_id].action[this.pattern_id] = { 'exec_dow': dow, 'exec_cal': cal_list };

			this.props.receiver.modifyScheduleProgram(program);

		}
	}

	// Tommy - 05/03/2021
	// handleDeleteSchedule = () =>{
	// 	this.props.receiver.deletePattern(this.pattern_id);
	// 	this.props.receiver.deleteScheduleProgram(this.props.param.program_id);
	// }

	rcvAddScheduleProgram(response) {
		if (response.result != 'NG') {
			this.props.receiver.next_component = 'Schedule';
			this.props.receiver.getScene();
		} else {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvModifyScheduleProgram(response) {
		if (response.result == 'OK') {
			this.is_modify_schedule_ok = true;
			this.checkModifyOK();
		} else {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	rcvModifyPattern(response) {
		if (response.result == 'OK') {
			this.is_modify_pattern_ok = true;
			this.checkModifyOK();
		} else {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	checkModifyOK = () => {
		if (this.is_modify_pattern_ok && this.is_modify_schedule_ok) {
			this.is_modify_schedule_ok = false;
			this.is_modify_pattern_ok = false;
			this.props.receiver.next_component = 'Schedule';
			this.props.receiver.getScene();
		}
	}

	rcvDeleteScheduleProgram(response) {
		if (response.result == 'OK') {
			this.is_delete_schedule_ok = true;
			this.checkDeleteOK();
		} else {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('del_fail'), 3000);
		}
	}

	rcvDeletePattern(response) {
		if (response.result == 'OK') {
			this.is_delete_pattern_ok = true;
			this.checkDeleteOK();
		} else {
			window.app.hideLoading();
			this.lastClickTime = false;
			window.app.showToast(this.props.receiver.getString('del_fail'), 3000);
		}
	}

	checkDeleteOK = () => {
		if (this.is_delete_pattern_ok && this.is_delete_schedule_ok) {
			this.is_delete_schedule_ok = false;
			this.is_delete_pattern_ok = false;
			this.props.receiver.next_component = 'Schedule';
			this.props.receiver.getScene();
		}
	}

	// Tommy - 05/03/2021
	handleRegister = () => {
		if (!this.preventMultipleTaps()) return;
		window.app.showLoading();

		this.handleSaveSchedule();
	}

	// Tommy - 05/03/2021
	handleDelete = () => {
		if (!this.preventMultipleTaps()) return;
		window.app.showLoading();

		this.props.receiver.deletePattern(this.pattern_id);
		this.props.receiver.deleteScheduleProgram(this.props.param.program_id);
	}

	//Tommy - 08/03/2021
	handleToggleRCProhOp = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.rop_proh = val
		} else if (action_details.rop_proh != null) {
			delete action_details.rop_proh
		}

		this.setState({ action_details: action_details });
	}

	//Tommy - 08/03/2021
	handleToggleRCProhMode = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.rmode_proh = val
		} else if (action_details.rmode_proh != null) {
			delete action_details.rmode_proh
		}

		this.setState({ action_details: action_details });
	}

	//Tommy - 08/03/2021
	handleToggleRCProhSP = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.rsp_proh = val
		} else if (action_details.rsp_proh != null) {
			delete action_details.rsp_proh
		}

		this.setState({ action_details: action_details });
	}

	//Tommy - 08/03/2021
	handleToggleRCProhFanstep = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.rfan_proh = val
		} else if (action_details.rfan_proh != null) {
			delete action_details.rfan_proh
		}

		this.setState({ action_details: action_details });
	}

	//Tommy - 08/04/2021
	handleChangeAV = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.av = val
		} else if (action_details.av != null) {
			delete action_details.av
		}

		this.setState({ action_details: action_details });
	}

	//Tommy - 12/04/2021
	handleChangeHeatSetback = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.sb_hsp = val
		} else if (action_details.sb_hsp != null) {
			delete action_details.sb_hsp
		}

		this.setState({ action_details: action_details });
	}

	//Tommy - 12/04/2021
	handleChangeCoolSetback = (val) => {
		let action_details = this.state.action_details;
		if (val != null) {
			action_details.sb_csp = val
		} else if (action_details.sb_csp != null) {
			delete action_details.sb_csp
		}

		this.setState({ action_details: action_details });
	}

	//Tommy - 24/06/2021 - Handle change special calendar
	handleChangeSpecialCalendar = (key) => {
		this.setState({ selected_calendar_id: key });
	}

	//Tommy - 24/06/2021 - Handle change special calendar
	handleCalendarList = (cal_id) => {
		let dow = [];
		for (let j in this.state.days_of_week) {
			if (this.state.days_of_week[j].is_checked) {
				dow.push(this.state.days_of_week[j].key);
			}
		}

		let cal_list = [];
		if (this.state.selected_calendar_id != '') cal_list.push(this.state.selected_calendar_id);

		let program = {};
		if (this.props.param.schedule.program[this.props.param.program_id] != null) {
			program = this.props.param.schedule.program[this.props.param.program_id];
		}
		if (program.action == null) {
			program.action = {};
		}

		program.action[this.props.param.pattern_id] = {};
		program.action[this.props.param.pattern_id].exec_dow = dow;
		program.action[this.props.param.pattern_id].exec_cal = cal_list;

		let param = this.props.param;

		param.edit = {};
		param.edit.schedule_name = this.state.schedule_name;
		param.edit.is_enabled = this.state.is_enabled;
		param.edit.hour = this.state.hour;
		param.edit.min = this.state.min;
		param.edit.days_of_week = this.state.days_of_week;
		param.edit.target = this.state.target;
		param.edit.action_details = this.state.action_details;
		param.edit.scene_list_display = this.state.scene_list_display;
		param.edit.selected_calendar_id = this.state.selected_calendar_id;

		param.program = program;
		param.program_id = this.props.param.program_id;
		param.schedule = this.props.param.schedule;
		param.calendar_id = cal_id;
		param.from = 'Add_Edit_Schedule_Home';

		this.props.content_handler('Add_Edit_Calendar', param);
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let selectStyle = {
			marginRight: 10,
			height: 30,
			textAlign: 'center',
			border: 'none',
			background: 'none',
			borderBottom: '1px solid #0098de',
			outline: 'none',
			verticalAlign: 'top',
			cursor: 'pointer',
		}

		let hourRange = [];
		let minRange = [];
		for (let i = 0; i < 24; i++) {
			if (makeTimeString(i) == this.state.hour) {
				hourRange.push(<option value={makeTimeString(i)} selected>{makeTimeString(i)}</option>)
			} else {
				hourRange.push(<option value={makeTimeString(i)}>{makeTimeString(i)}</option>)
			}
		}

		for (let j = 0; j < 60; j++) {
			if (makeTimeString(j) == this.state.min) {
				minRange.push(<option value={makeTimeString(j)} selected>{makeTimeString(j)}</option>)
			} else {
				minRange.push(<option value={makeTimeString(j)}>{makeTimeString(j)}</option>)
			}
		}

		let action_details = this.state.action_details;

		// Tommy - 24/03/2021 - Add to determine device orientation
		let is_landscape = this.props.width > this.props.height;

		// Tommy - 11/04/2021
		//Controller Options Validation
		let available_functions = this.props.receiver.active_controller.available_functions;
		let is_show_rc_proh = false;
		let is_show_scenes = false;
		let is_show_setback = false;
		if (available_functions.scene) is_show_scenes = true;
		if (available_functions.setback) is_show_setback = true;
		if (available_functions.rc_proh) is_show_rc_proh = true;

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>

					{/* Tommy - 05/03/2021 */}
					<Top_Bar
						width={this.props.width}
						title={this.props.param.program_id == null ? this.props.receiver.getString('add_sched') : this.props.receiver.getString('edit_sched')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>

					{/* <div style={{width: 100, display: 'inline-block', textAlign: 'left',}} onClick={this.handlePrevious}>
						<img src={back} style={{width: 25, marginTop: 10, marginLeft: 10}}/>
					</div>
					<div style={{width: this.props.width-200, textAlign: 'center', display: 'inline-block' }}>
						<span className="header">{this.props.param.program_id==null?this.props.receiver.getString('add_sched'):this.props.receiver.getString('edit_sched')}</span> 
	    			</div>
	    			<div style={{display: 'inline-block', width: 100, textAlign: 'right'}} >
	    				<img src={delete_icon} style={{display: this.props.param.program_id!=null?'block':'none', width: 25, marginTop: 10, marginRight: 10}} onClick={this.handleDeleteSchedule} />
	    			</div> */}

					{/* Tommy - 24/03/2021  */}
					<div style={{ textAlign: 'left', height: this.props.height - 140, overflow: 'auto' }}>
						<div style={{ marginTop: 20 }}>
							<div style={{ display: 'inline-block', width: this.props.width - 100, marginLeft: 50 }}>
								<Editbox id='schedule_name' style={{}} placeholder={this.props.receiver.getString('name')} inputType='text' onChange={(event) => this.handleChangeScheduleName(event.target.value)} value={this.state.schedule_name} />
							</div>
						</div>

						<div style={{ marginTop: 20, textAlign: 'left', marginLeft: 50 }}>
							<span className='subtitle' style={{ verticalAlign: 'top', display: 'inline-block' }}>Time: </span>
							<select id='Command_Schedule_Timer_Hour' defaultValue={this.state.hour} onChange={(event) => this.handleChangeScheduleTimerHour(event.target.value)} style={selectStyle}>
								{hourRange}
							</select>
							<span className='subtitle' style={{ verticalAlign: 'top', display: 'inline-block' }}>: </span>
							<select id='Command_Schedule_Timer_Min' defaultValue={this.state.min} onChange={(event) => this.handleChangeScheduleTimerMin(event.target.value)} style={selectStyle}>
								{minRange}
							</select>
						</div>

						<div style={{ marginTop: 20, marginBottom: 20, marginLeft: 50 }}>
							<Repeat
								receiver={this.props.receiver}
								days_of_week={this.state.days_of_week}
								handleChangeDaysOfWeek={this.handleChangeDaysOfWeek}
								repeatKeyword={'repeat'}
							/>
						</div>

						{/* Tommy - 24/06/2021 Add Special Day Calendar*/}
						<div style={{ marginLeft: 20 }}>
							<Special_Calendar
								receiver={this.props.receiver}
								selected_calendar_id={this.state.selected_calendar_id}
								calendar_list={this.props.param.schedule.calendar}
								handleCalendarList={this.handleCalendarList}
								handleChangeSpecialCalendar={this.handleChangeSpecialCalendar}
								width={this.props.width}
								height={this.props.height}
							/>
						</div>

						<div style={{ marginTop: 20, marginRight: 10, textAlign: 'left', marginLeft: 50 }}>
							<div style={{ paddingTop: 2, display: 'inline-block' }}>
								<span>{this.props.receiver.getString('enable')}</span>
							</div>
							<Switch style={{ display: 'inline-block', verticalAlign: 'top', marginLeft: 10 }} is_enabled={this.state.is_enabled} handleToggleSwitch={this.handleToggleEnable} />
						</div>

						<div style={{ marginTop: 20, verticalAlign: 'top', marginLeft: 50 }}>
							<span style={{ fontWeight: 600 }}>{this.props.receiver.getString('select_devices')}</span>
							<Select
								select_style={{ width: this.props.width - 100, marginTop: 10, padding: 20, height: 'unset' }}
								options={this.devices}
								value={this.state.target}
								onSelect={this.handleChangeTarget}
							/>
						</div>

						<div style={{ marginTop: 20, verticalAlign: 'top', marginLeft: 50, width: this.props.width - 100 }}>
							<Button id='toggle_modal' style={{ color: '#6e6e6e', width: '100%', margin: 0, marginTop: 20, marginRight: 'auto', marginLeft: 'auto', textAlign: 'center' }} bgColor={'white'} onClick={this.handleToggleModal}>{this.props.receiver.getString('select_operation')}</Button>
						</div>

						{/* Tommy - 08/04/2021 - Hide title if user does not have any scenes */}
						{this.state.scene_list_display.length > 0 ? <div style={{ display: is_show_scenes ? 'block' : 'none', marginTop: 20, verticalAlign: 'top', marginLeft: 50 }}>
							<span style={{ fontWeight: 600 }}>{this.props.receiver.getString('select_scene')}</span>
						</div> : null}

						{/* Tommy - 25/03/2021 - Align list of scenes to be centered, and width according to device width */}
						{/* Tommy - 13/04/2021 - Check for scene available functions */}
						<div style={{ display: is_show_scenes ? 'block' : 'none', marginTop: 5, verticalAlign: 'top', marginLeft: 40 }}>
							{this.state.scene_list_display.map((item, i) => {
								return (
									<div style={{ boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)', margin: 10, display: 'inline-block', width: is_landscape ? 150 : (this.props.width - 110) / 2, height: 80, backgroundColor: item.is_checked ? this.props.colours.appBlue : 'white', borderRadius: 20, textAlign: 'center' }} onClick={() => this.handleSelectScene(item.key)}>
										<span style={{ height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', color: item.is_checked ? 'white' : 'black' }}>{item.display}</span>
									</div>
								)
							})}
						</div>

						{/* <div style={{ marginTop: 20, verticalAlign: 'top', marginLeft: 50}}>
							<div>
								<span>{this.props.receiver.getString('select_scene')}</span>
							</div>
						
							{this.state.scene_list_display.map((item, i) => {
								return (
									<div style={{ boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)', margin: 10, display: 'inline-block', width: 150 , height: 80, backgroundColor: item.is_checked ? this.props.colours.appBlue : 'white', borderRadius: 20, textAlign: 'center' }} onClick={() => this.handleSelectScene(item.key)}>
										<span style={{ height: 80, display: 'flex', alignItems: 'center', justifyContent: 'center', color: item.is_checked ? 'white' : 'black' }}>{item.display}</span>
									</div>
								)
							})}
						</div> */}
					</div>

					<Modal position={"unset"} width={"100%"} height={this.props.height} is_show={this.state.is_show_modal} handleToggle={this.handleToggleModal}>
						<div style={{ background: 'lightgray', padding: 20 }}>
							<span style={{ fontWeight: 600 }}>{this.props.receiver.getString('select_operation')}</span>
						</div>

						{window.app.state.point_list[this.state.target] != null ? (window.app.state.point_list[this.state.target].type == 'Status' || window.app.state.point_list[this.state.target].type == 'Switch' ||
							window.app.state.point_list[this.state.target].type == 'LevelSw' || window.app.state.point_list[this.state.target].type == 'Rgbw' ||  window.app.state.point_list[this.state.target].type == 'Dehumi' ||
							window.app.state.point_list[this.state.target].type == 'Ac' || window.app.state.point_list[this.state.target].type == 'Hrv' ||
							window.app.state.point_list[this.state.target].type == 'SensorStat' ?
							<Command_Power receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeStat={this.handleChangeStat} />
							: null) : null}

						{window.app.state.point_list[this.state.target] != null ? (window.app.state.point_list[this.state.target].type == 'Ac' || window.app.state.point_list[this.state.target].type == 'Hrv' ?
							<div>
								<Command_Setpoint point_info={window.app.state.point_list[this.state.target]} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeSP={this.handleChangeSP} />
								<Command_Fanstep point_info={window.app.state.point_list[this.state.target]} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeFanstep={this.handleChangeFanstep} />
								<Command_Mode point_info={window.app.state.point_list[this.state.target]} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeMode={this.handleChangeMode} />
							</div>
							: null) : null}

						{window.app.state.point_list[this.state.target] != null ? (window.app.state.point_list[this.state.target].type == 'Dehumi' ?
							<div>
								<Command_Hum_Setpoint point_info={window.app.state.point_list[this.state.target]} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeHumSP={this.handleChangeHumSP} />
								<Command_Fanstep point_info={window.app.state.point_list[this.state.target]} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeFanstep={this.handleChangeFanstep} />
							</div>
							: null) : null}

						{window.app.state.point_list[this.state.target] != null ? (window.app.state.point_list[this.state.target].type == 'Switch' || window.app.state.point_list[this.state.target].type == 'LevelSw' || window.app.state.point_list[this.state.target].type == 'Dehumi' ||
							window.app.state.point_list[this.state.target].type == 'Ac' || window.app.state.point_list[this.state.target].type == 'Hrv' || window.app.state.point_list[this.state.target].type == 'Rgbw' ?
							<Command_Off_Timer receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeOffTimer={this.handleChangeOffTimer} />
							: null) : null}

						{window.app.state.point_list[this.state.target] != null ? (window.app.state.point_list[this.state.target].type == 'Ac' && is_show_setback ?
							<div>
								<Command_Setback_Cool receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeCoolSetback={this.handleChangeCoolSetback} />
								<Command_Setback_Heat receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeHeatSetback={this.handleChangeHeatSetback} />
							</div>
							: null) : null}


						{window.app.state.point_list[this.state.target] != null ? ((window.app.state.point_list[this.state.target].type == 'Ac' || window.app.state.point_list[this.state.target].type == 'Hrv') && is_show_rc_proh ?
							<Command_RC_Proh_Op receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleToggleRCProhOp={this.handleToggleRCProhOp} />
							: null) : null}

						{window.app.state.point_list[this.state.target] != null ? (window.app.state.point_list[this.state.target].type == 'Ac' && is_show_rc_proh ?
							<div>
								<Command_RC_Proh_Mode receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleToggleRCProhMode={this.handleToggleRCProhMode} />
								<Command_RC_Proh_SP receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleToggleRCProhSP={this.handleToggleRCProhSP} />
								<Command_RC_Proh_Fanstep receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleToggleRCProhFanstep={this.handleToggleRCProhFanstep} />
							</div>
							: null) : null}

						{window.app.state.point_list[this.state.target] != null ? (window.app.state.point_list[this.state.target].type == 'Switch' || window.app.state.point_list[this.state.target].type == 'Status' ||
							window.app.state.point_list[this.state.target].type == 'LevelSw' || window.app.state.point_list[this.state.target].type == 'Ac' || window.app.state.point_list[this.state.target].type == 'Dehumi' ||
							window.app.state.point_list[this.state.target].type == 'Hrv' || window.app.state.point_list[this.state.target].type == 'Rgbw' ||
							window.app.state.point_list[this.state.target].type == 'Shutter' || window.app.state.point_list[this.state.target].type == 'Lock' ||
							window.app.state.point_list[this.state.target].type == 'SensorStat'  || window.app.state.point_list[this.state.target].type == 'Occupied' ?
							<Command_Notification receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeNotification={this.handleChangeNotification} />
							: null) : null}

						{window.app.state.point_list[this.state.target] != null ? (window.app.state.point_list[this.state.target].type == 'Level' || window.app.state.point_list[this.state.target].type == 'LevelSw' ?
							<Command_Level point_info={window.app.state.point_list[this.state.target]} receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeAV={this.handleChangeAV} />
							: null) : null}

						{window.app.state.point_list[this.state.target] != null ? (window.app.state.point_list[this.state.target].type == 'Lock' ?
							<Command_Lock receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeLockStatus={this.handleChangeLockStatus} />
							: null) : null}

						{window.app.state.point_list[this.state.target] != null ? (window.app.state.point_list[this.state.target].type == 'Shutter' ?
							<Command_Shutter receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeShutterStatus={this.handleChangeShutterStatus} />
							: null) : null}

						{window.app.state.point_list[this.state.target] != null ? (window.app.state.point_list[this.state.target].type == 'Rgbw' ?
							<Command_RGB_Input receiver={this.props.receiver} width={this.props.width} action_details={action_details} handleChangeRGB={this.handleChangeRGB} />
							: null) : null}

						<Button id='modal_confirm' style={{ width: '100%', margin: 0, marginTop: 20, marginRight: 'auto', marginLeft: 'auto', textAlign: 'center' }} bgColor={this.props.colours.appBlue} onClick={this.handleToggleModal}>{this.props.receiver.getString('confirm')}</Button>
					</Modal>
				</div>
			</div>
		)
	}
}